import axios from "axios";
import Cookies from "js-cookie";
import { Notifications } from "../notification";
import * as Vars from "../logic/Vars";

export class User{

  //Returns true if the user is signed in and false if not or the token is not valid
  static isSignedIn(){
    return new Promise((resolve) => {
      var token = Cookies.get("_console_token");

      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/auth/check.php",
        method: "GET",
        params: {
          _console_token: token
        }
      }).then(function(response){
        resolve(response.data.status === 200); //Return if the session is valid
      });
    });
  }

  //Does the whole logout process (clientside-only)
  static logoutAndRedirect(instance){
    Cookies.remove("_console_token");
    instance.$router.replace("login");
    Notifications.show("Logout was successfully");
  }
}
